import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

const BASE_PATH = `${SERVICE_ENDPOINT.TRANSPORT}/fleet-status`;

export const getFleetStatusHistory = async (type, ref) => {
    try {
        const response = await gatewayInstance.get(
            `${BASE_PATH}/type/${type}/reference/${ref}`
        );
        return response.data;
    } catch (e) {
        console.error(e);
        return [];
    }
};
